export const GradientJoin = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.183 6.11697C7.889 5.8571 6.54543 6.03115 5.36036 6.61215C4.17529 7.19315 3.21486 8.14869 2.62782 9.33078C2.04077 10.5129 1.85986 11.8555 2.11312 13.1508C2.36638 14.4461 3.03966 15.6218 4.0287 16.4957C5.01773 17.3697 6.26733 17.8931 7.58396 17.985C8.90059 18.0768 10.2108 17.732 11.3116 17.0039C12.4124 16.2758 13.2425 15.2051 13.6732 13.9575C14.1039 12.7099 14.1112 11.3551 13.694 10.103M14.813 17.8831C16.1084 18.1443 17.4537 17.9705 18.6402 17.3888C19.8267 16.8071 20.788 15.85 21.3748 14.666C21.9616 13.482 22.1412 12.1374 21.8856 10.8409C21.63 9.54446 20.9536 8.36862 19.9613 7.49596C18.969 6.62329 17.7164 6.10261 16.3979 6.01475C15.0794 5.92688 13.7687 6.27675 12.6694 7.01003C11.5701 7.74332 10.7436 8.819 10.3183 10.0701C9.8929 11.3212 9.89246 12.6777 10.317 13.9291"
      stroke="url(#paint0_linear_3173_55774)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3173_55774"
        x1="12.0003"
        y1="5.99951"
        x2="12.0003"
        y2="18.0015"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE6EC5" />
        <stop offset="1" stopColor="#A744F6" />
      </linearGradient>
    </defs>
  </svg>
)
